// extracted by mini-css-extract-plugin
export default {"form":"Checkout_form__hGDhb","control":"Checkout_control__ELOZ1","actions":"Checkout_actions__r6JW8","submit":"Checkout_submit__wanRU","invalid":"Checkout_invalid__eOqcp"};